import React, {useEffect, useState} from 'react';
import TextInput from '../common/generic/TextInput';
import Button from 'react-bootstrap/Button';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import FavsComp from './FavsComp';
import { TitleBar, IconHelp } from '../common/theme';
import { toArray, isObjectEmpty, buildUniqueArrayFromField } from '../../Utils';
import { getCreateUserStatus, getCreateFeildStatus, debugMode, hideMagies } from '../../ApiHelper';
import Dialog from '../common/Dialog';

const SelectInputHelp = ({ name, layout, label, buttonCallback, tooltip, error, items, selected, ...rest }) => <>
    <Row className='form-group'>
        <Col xs={layout[0]} style={{fontWeight:'bold'}} ><label htmlFor={name}>{label}</label></Col>
        <Col xs={layout[1]}>
            <select
              id = {name}
              name={name}
              className="form-control"
              value={selected}
              {...rest}
            >
              {items.map((item,i)=>
                <option key={i} value={item.value}>{item.label} </option>
              )}
            </select>
        </Col> 
        <Col xs={layout[2]}><IconHelp tooltip={tooltip}/></Col>
    </Row>
    <Row><Col xs='12'>{error && <div className="alert alert-danger">{error}</div>}</Col></Row>
  </>;

SelectInputHelp.defaultProps = {
  layout: [2,8,2]
};

const SelectInputInstruct = ({ name, layout, label, buttonCallback, instruct, error, items, selected, ...rest }) => <>
    <Row className='form-group'>
        <Col xs={layout[0]} style={{fontWeight:'bold'}} ><label htmlFor={name}>{label}</label></Col>
        <Col xs={layout[1]}>
            <select
              id = {name}
              name={name}
              className="form-control"
              value={selected}
              {...rest}
            >
              {items.map((item,i)=>
                <option key={i} value={item}>{item} </option>
              )}
            </select>
        </Col> 
        <Col xs={layout[2]}>{instruct}</Col>
    </Row>
    <Row><Col xs='12'>{error && <div className="alert alert-danger">{error}</div>}</Col></Row>
  </>;

const TextInputHelp = ({ name, layout, label, buttonCallback, tooltip, error, ...rest }) => <>
    <Row className='form-group'>
        <Col xs={layout[0]} style={{fontWeight:'bold'}} ><label htmlFor={name}>{label}</label></Col>
        <Col xs={layout[1]}>
        <input
            type="text"
            id = {name}
            name={name}
            className="form-control"
            {...rest}
        />
        </Col> 
        <Col xs={layout[2]}><IconHelp tooltip={tooltip}/></Col>
    </Row>
    <Row><Col xs='12'>{error && <div className="alert alert-danger">{error}</div>}</Col></Row>
  </>;

const TextInputInstruct = ({ name, layout, label, buttonCallback, instruct, error, ...rest }) => <>
    <Row className='form-group'>
        <Col xs={layout[0]} style={{fontWeight:'bold'}} ><label htmlFor={name}>{label}</label></Col>
        <Col xs={layout[1]}>
        <input
            type="text"
            id = {name}
            name={name}
            className="form-control"
            {...rest}
        />
        </Col> 
        <Col xs={layout[2]}>{instruct}</Col>
    </Row>
    <Row><Col xs='12'>{error && <div className="alert alert-danger">{error}</div>}</Col></Row>
  </>;

TextInputHelp.defaultProps = {
    layout: [2,8,2]
  };

const TextInputCheckBoxHelp = ({ name, label, placeholder, buttonCallback, tooltip, ...rest }) => 
  <Row className='form-group'>
    <Col xs='2' style={{fontWeight:'bold'}} ><label htmlFor={name}>{label}</label></Col>
    <Col xs='2'>
    <input
        type="checkbox"
        id = {name}
        name={name}
        {...rest}
    />
    </Col> 
    <Col xs='2'><IconHelp tooltip={tooltip}/></Col>
  </Row>;

const TextInputCheckBoxInstruct = ({ name, layout, label, placeholder, buttonCallback, instruct, ...rest }) => 
  <Row className='form-group'>
    <Col xs={layout[0]} style={{fontWeight:'bold'}} ><label htmlFor={name}>{label}</label></Col>
    <Col xs={layout[1]}>
    <input
        type="checkbox"
        id = {name}
        name={name}
        {...rest}
    />
    </Col> 
    <Col xs={layout[2]}>{instruct}</Col>
  </Row>;

const ProfilePage = ({pageState}) => {
  const {request} = pageState;

  const [dataLoaded, setDataLoaded] = useState(false);
  const [classList,setClassList] = useState([]);
  
  const [className,setClassName] = useState('');
  const [classLogin,setClassLogin] = useState('');
  const [classEmail,setClassEmail] = useState('');
  const [classPass,setClassPass] = useState('');

  const [masterLevel,setMasterLevel] = useState('80');
  //const [theme,setTheme] = useState('default');
  const [reward,setReward] = useState('none');
  const [numbersChecked,setNumbersChecked] = useState(false);

  const [mmOrient, setMMOrient] = useState('Both');
  const [mmAnimationsChecked,setMMAnimationsChecked] = useState(true);
  const [mmDrillLength,setMMDrillLength] = useState(60);
  const [mmDrillsPerSession,setMMDrillsPerSession] = useState(6);
  const [mmMasterThreshold,setMMMasterThreshold] = useState(3);

  const [currentClass,setCurrentClass] = useState({});
  const [editClassContact, setEditClassContact] = useState(false);
  const [editClassOptions, setEditClassOptions] = useState(false);
  const [editMadMinuteOptions, setEditMadMinuteOptions] = useState(false);
  
  const [classID,setClassID] = useState('');
  const [classFavs,setClassFavs] = useState('');

  const [dialog, setDialog] = useState({show:false});

  const [hasMadMinute, setHasMadMinute] = useState(false);

  useEffect(() => {

    // if not admin then find all the classes in the school to be used for checking if the class name can be changed
    if(!pageState.database['classList'] && pageState.database['getCustomer'] && classList.length === 0){
      let query = {
        params: pageState.database['getCustomer'].data.ID,
        altName: 'classList',
        func:'getAllClasses',
      };
      request(query); 
    }
    if(pageState.database['classList'] && pageState.database['classList'].data && classList.length==0){
      setClassList(toArray(pageState.database['classList'].data));
    }

    if(pageState.database['getAllClasses'] && pageState.database['getAllClasses'].data){
      if(pageState.classID){ // isAdmin
        setCurrentClass(pageState.database['getAllClasses'].data[pageState.classID]);
        setClassID(pageState.classID);
      }
      else{ // is single teacher
        setCurrentClass(pageState.database['getAllClasses'].data[sessionStorage.getItem('userID')]);
        setClassID(sessionStorage.getItem('userID'));       
      }
    }

    if(!isObjectEmpty(currentClass) && !dataLoaded){
      setDataLoaded(true);
      setClassName(currentClass.Classname);
      setClassLogin(currentClass.Username);
      setClassEmail(currentClass.Email||'');
      setClassPass(currentClass.Password);

      setNumbersChecked(currentClass.NumberMenus==='Y');
      setMasterLevel(currentClass.MasterLevel);
      //setTheme(currentClass.Theme);
      if(!currentClass.Reward)
        currentClass.Reward = 'Login Dependent';
      setReward(currentClass.Reward);

      setClassID(currentClass.ClassID);
      setClassFavs(currentClass.Favorites||'');

      if(currentClass.MadMinuteOptions){
        let madMinuteOptions = JSON.parse(currentClass.MadMinuteOptions); 
        setMMAnimationsChecked(madMinuteOptions.animations);
        setMMDrillLength(madMinuteOptions.drillLength); 
        setMMDrillsPerSession(madMinuteOptions.drillSessions); 
        setMMMasterThreshold(madMinuteOptions.masterThreshold);       
        setMMOrient(madMinuteOptions.orient);      
      }

      let hasMMinute = Object.keys(pageState.database['getAllPrograms'].data).reduce((acc, key) => {
        if(pageState.database['getAllPrograms'].data[key].NAME==='MMM')
          acc = true;
        return acc;
      }
      ,false);
      //console.log('hasMadMinute', hasMMinute);
      setHasMadMinute(hasMMinute);
      //pageState.database['getAllPrograms'].data
    }
  });

  const saveContacts = () =>{
    let query = {
        params:`${currentClass.ClassID}~${className}~${classLogin}~${classEmail}~${classPass}`,
        func:'saveClassInfo'   
    };

    let classNames = buildUniqueArrayFromField(classList,'Classname');
    if(className!==currentClass.Classname){
      let status = getCreateUserStatus('Name',className, true, classNames);
      if(status.error){
        setDialog({title:'Problem with the Class name...', text:status.error, show:true});
        return;
      }
    }

    let loginNames = buildUniqueArrayFromField(classList,'Username');
    if(classLogin!==currentClass.Username){
      let status = getCreateUserStatus('Name',classLogin, true, loginNames);
      if(status.error){
        setDialog({title:'Problem with the Username...', text:status.error, show:true});
        return;
      }
    }
    
    let statusPass = getCreateFeildStatus('Password',classPass, true);
    if(statusPass.error){
      setDialog({title:'Problem with the Password...', text:statusPass.error, show:true});
      return;
    }

    let statusEmail = getCreateFeildStatus('Email',classEmail, false);
    if(statusEmail.error){
      setDialog({title:'Problem with the Email...', text:statusEmail.error, show:true});
      return;
    }
    let cachedClass = {};
    if(pageState.classID){ // isAdmin
      cachedClass = pageState.database['getAllClasses'].data[pageState.classID];
    }
    else{ // is single teacher
      cachedClass = toArray(pageState.database['getAllClasses'].data).find(e=>e.ClassID===pageState.database['teacherID']);      
    }
    cachedClass['Password'] = classPass;
    cachedClass['Classname'] = className;
    cachedClass['Username'] = classLogin;
    cachedClass['Email'] = classEmail;

    request(query); 
    setEditClassContact(false);
  };

  const cancelContacts = () =>{
    setClassName(currentClass.Classname);
    setClassLogin(currentClass.Username);
    let email = (currentClass.Email) ? (currentClass.Email) :'';
    setClassEmail(email);
    setClassPass(currentClass.Password);    
    setEditClassContact(false);
  }; 

  const saveOptions = () =>{
    let query = {
        //params:`${currentClass.ClassID}~${masterLevel}~${(numbersChecked)?'Y':'N'}~${reward}~${theme}`,
        params:`${currentClass.ClassID}~${masterLevel}~${(numbersChecked)?'Y':'N'}~${reward}`,
        func:'saveClassOptions'   
    };

    if(isNaN(masterLevel)){
      setDialog({title:'Problem with the Class Options...', text:'Master Level needs to a number between 0 - 100', show:true});
      return;
    }
    if(masterLevel < 0 || masterLevel>100){
      setDialog({title:'Problem with the Class Options...', text:'Master Level needs to a number between 0 - 100', show:true});
      return;
    }

    let cachedClass = {};
    if(pageState.classID){ // isAdmin
      cachedClass = pageState.database['getAllClasses'].data[pageState.classID];
    }
    else{ // is single teacher
      cachedClass = toArray(pageState.database['getAllClasses'].data).find(e=>e.ClassID===pageState.database['teacherID']);   
    }
    cachedClass['NumberMenus'] = (numbersChecked)?'Y':'N';
    cachedClass['MasterLevel'] = masterLevel;
    //cachedClass['Theme']=theme;
    cachedClass['Reward']=reward;

    request(query); 
    setEditClassOptions(false);
  };

  const cancelOptions = () =>{
    setNumbersChecked(currentClass.NumberMenus==='Y');
    setMasterLevel(currentClass.MasterLevel); 
    //setTheme(currentClass.Theme); 
    if(!currentClass.Reward)
      currentClass.Reward = 'Login Dependent';
    setReward(currentClass.Reward);
    setEditClassOptions(false);
  }; 

  const saveMMOptions = () =>{
    
    let madMinuteOptions = {
      orient: mmOrient,
      animations: mmAnimationsChecked,
      drillLength: mmDrillLength,
      drillSessions: mmDrillsPerSession,
      masterThreshold:mmMasterThreshold
    };

    let query = {
        params:`${currentClass.ClassID}~${JSON.stringify(madMinuteOptions)}`,
        func:'saveMadMinuteOptions'   
    };

    if(isNaN(mmDrillLength)){
      setDialog({title:'Problem with the Mad Minute Options...', text:'Drill length needs to a number between 30 - 120', show:true});
      return;
    }
    if(mmDrillLength < 30 || mmDrillLength> 120){
      setDialog({title:'Problem with the Mad Minute Options...', text:'Drill length needs to a number between 30 - 120', show:true});
      return;
    }
    if(isNaN(mmDrillsPerSession)){
      setDialog({title:'Problem with the Mad Minute Options...', text:'Drills per session needs to a number between 3 - 5', show:true});
      return;
    }
    if(mmDrillsPerSession < 3 || mmDrillsPerSession > 15){
      setDialog({title:'Problem with the Mad Minute Options...', text:'Drills per session needs to a number between 3 - 15', show:true});
      return;
    }
    if(isNaN(mmMasterThreshold)){
      setDialog({title:'Problem with the Mad Minute Options...', text:'Master threshold needs to a number between 1 - 7', show:true});
      return;
    }
    if(mmMasterThreshold < 1 || mmMasterThreshold > 7){
      setDialog({title:'Problem with the Mad Minute Options...', text:'Master threshold needs to a number between 1 - 7', show:true});
      return;
    }

    let cachedClass = {};
    if(pageState.classID){ // isAdmin
      cachedClass = pageState.database['getAllClasses'].data[pageState.classID];
    }
    else{ // is single teacher
      cachedClass = toArray(pageState.database['getAllClasses'].data).find(e=>e.ClassID===pageState.database['teacherID']);   
    }
    cachedClass['MadMinuteOptions'] = JSON.stringify(madMinuteOptions);
    request(query); 

    setEditMadMinuteOptions(false);
  };
  
  const cancelMMOptions = () =>{

    let madMinuteOptions = {
      orient: 'Both',
      animations: true,
      drillLength: 60,
      drillSessions: 6,
      masterThreshold: 3
    };

    if(currentClass.MadMinuteOptions)
      madMinuteOptions = JSON.parse(currentClass.MadMinuteOptions);

    setMMAnimationsChecked(madMinuteOptions.animations);
    setMMDrillLength(madMinuteOptions.drillLength); 
    setMMDrillsPerSession(madMinuteOptions.drillSessions); 
    setMMMasterThreshold(madMinuteOptions.masterThreshold); 
    setMMOrient(madMinuteOptions.orient);
    setEditMadMinuteOptions(false);
  }; 
  const isLTIMode=()=>(sessionStorage.getItem('LTIMode') !== null);
  return (
    <>  
        {/* <Row><Button variant='danger' >Delete Class</Button></Row> <br/>  */}
        <Form>
          {!isLTIMode()&&<>
              <TitleBar>
                  <Col  style={{textAlign: 'left', color: 'white' }} xs='12'><h3>Info</h3></Col>   
              </TitleBar>
              <br/>
              <TextInput name="name" onChange={e=>setClassName(e.target.value)} value={className} label="Name:" disabled={!editClassContact}/>
              <TextInput name="login" onChange={e=>setClassLogin(e.target.value)} value={classLogin} label="Username:" disabled={!editClassContact}/>
              <TextInput name="email" onChange={e=>setClassEmail(e.target.value)} value={classEmail} label="Email:" disabled={!editClassContact}/>
              <TextInput name="pass" onChange={e=>setClassPass(e.target.value)} value={classPass} label="Password:" disabled={!editClassContact}/>
              {!editClassContact && <><Button onClick={()=>setEditClassContact(true)} variant={'success'} > Edit </Button> </>}
              {editClassContact && <>
              <Button variant={'success'} onClick={saveContacts}> Save </Button> &nbsp;
              <Button variant={'danger'} onClick={cancelContacts} > Cancel </Button> 
              </>}
              <br/><br/>
              <TitleBar>
                <Col  style={{textAlign: 'left', color: 'white' }} xs='12'><h3>Options</h3></Col>   
              </TitleBar>
            </>}
            {isLTIMode()&&<>
              <TitleBar>
                <Col  style={{textAlign: 'left', color: 'white' }} xs='12'><h3>{className}</h3></Col>   
              </TitleBar>
            </>}

            <br/>
            <TextInputHelp layout={[2,2,2]} name="masterLevel" label="Master Level:" onChange={e=>setMasterLevel(e.target.value)} value={masterLevel} tooltip="The percent a student needs to pass activities" disabled={!editClassOptions}/>          
            <TextInputCheckBoxHelp name="numberedMenus" label="Numbered Menus:" onChange={e=>setNumbersChecked(e.target.checked)} checked={numbersChecked} tooltip="Put numbers in front of menu names" disabled={!editClassOptions} />
            {/* <SelectInputHelp  name="theme" label="Program Theme:" onChange={e=>setTheme(e.target.value)} tooltip="The look of the student programs" items={['default','landscapes','standard']} selected={theme} disabled={!editClassOptions} /> */}
            {!hideMagies && <SelectInputHelp  name="reward" label="Reward Type:" onChange={e=>setReward(e.target.value)} tooltip="Student collectable rewards" 
              items={[
                {value:'Badges',label:'Badges - (Earn badges based on progress)'},
                {value:'Magies', label:'Magies - (Hatch & evolve characters based on progress)'},
                {value:'Login Dependent', label:'Login Dependent - (Assigns Magies to Standard theme & Badges to Senior theme)'},
                {value:'None', label: 'None - (No Badges or Magies for either theme)'}
              ]} selected={reward} disabled={!editClassOptions} />}
            {!editClassOptions && <><Button onClick={()=>setEditClassOptions(true)} variant={'success'} > Edit </Button> </>}
            {editClassOptions && <>
            <Button variant={'success'} onClick={saveOptions}> Save </Button> &nbsp;
            <Button variant={'danger'} onClick={cancelOptions} > Cancel </Button> 
            </>}
            <br/><br/>

            {hasMadMinute && <>
              <TitleBar>
                  <Col  style={{textAlign: 'left', color: 'white' }} xs='12'><h3>Mad Minute Options</h3></Col>
              </TitleBar>
              <br/>
              <TextInputInstruct layout={[2,2,8]} name="masterLevel" label="Drill Length:" onChange={e=>setMMDrillLength(e.target.value)} value={mmDrillLength} disabled={!editMadMinuteOptions} instruct={'The number of seconds in a single drill. This can be set between 30 - 120'}/>
              <TextInputInstruct layout={[2,2,8]} name="masterLevel" label="Drill per Session:" onChange={e=>setMMDrillsPerSession(e.target.value)} value={mmDrillsPerSession} disabled={!editMadMinuteOptions} instruct={'The number of drills a student is expected to do in a single day. This can be set between 3 - 15'}/>
              <TextInputInstruct layout={[2,2,8]} name="masterLevel" label="Mastery Threshold:" onChange={e=>setMMMasterThreshold(e.target.value)} value={mmMasterThreshold} disabled={!editMadMinuteOptions} instruct={'If the student consistently answers a fact in less than this number of seconds they will be considered to have mastered the fact. A setting of 1 or 2 seconds is fast (perhaps for advanced students) and a setting greater then 4 seconds is slow ( perhaps for remdial students).  This can be set between 1 - 7'}/>
              <SelectInputInstruct layout={[2,2,8]} name="orientation" label="Question Orientation:" onChange={e=>setMMOrient(e.target.value)} instruct={'The presentation format of the math facts. If set to \'Both\', a different presentation will be chosen for each drill. Math facts can be presented as horizontal, vertical or both.'} items={['Both','Horizontal','Vertical']} selected={mmOrient} disabled={!editMadMinuteOptions} />
              {/* <TextInputCheckBoxInstruct layout={[2,2,8]} name="rewardAnimations" label="Reward Animations:" onChange={e=>setMMAnimationsChecked(e.target.checked)} checked={mmAnimationsChecked} instruct={'Enable or disable reward animations'} disabled={!editMadMinuteOptions} /> */}

              {!editMadMinuteOptions && <><Button onClick={()=>setEditMadMinuteOptions(true)} variant={'success'} > Edit </Button> </>}
              
              {editMadMinuteOptions && <>
              <Button variant={'success'} onClick={saveMMOptions}> Save </Button> &nbsp;
              <Button variant={'danger'} onClick={cancelMMOptions} > Cancel </Button> 
              </>}
            </>}
            <br/><br/>

            <TitleBar>
                <Col  style={{textAlign: 'left', color: 'white' }} xs='12'><h3>Favorite Programs</h3></Col>   
            </TitleBar>
            <FavsComp pageState={{classes:pageState.database['getAllClasses'], request, classID, classFavs}}/>
        </Form>
        <Dialog dialogState={{dialog, setDialog}} />
    </>
  );
};
 
export default ProfilePage;